import { QueryClient } from 'react-query';

export const filesQueryClient = new QueryClient();
